import React, { Component } from "react";
import { ModalContext } from "./ModalContext";

export class ModalProvider extends Component {
  state = {
    modal: { isOpen: false, modalId: "" },
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.isPopUpOpen !== this.props.isPopUpOpen) {
      this.setState({ isOpen: this.props.isPopUpOpen });
    }
  };

  toggleModal(modalId) {
    this.setState((state) => ({
      modal:
        state.modal.isOpen && !modalId
          ? { isOpen: false }
          : { isOpen: true, modalId: modalId },
    }))
  }

  render() {
    return (
      <ModalContext.Provider
        value={{
          isOpen: this.state.modal.isOpen,
          toggleModal: this.toggleModal.bind(this),
          modalId: this.state.modal.modalId,
        }}
      >
        {this.props.children}
      </ModalContext.Provider>
    );
  }
}
